import React, { useRef } from 'react'
import "./form.scss"
import emailjs from "emailjs-com"
//Imagens:
import ImgForm from "../../assets/form/vetorForm.png"
import { useTranslation, Trans } from 'react-i18next';
import { useState } from 'react';

function Form() {
  const form = useRef();

  const { t } = useTranslation()

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [company, setCompany] = useState('')
  const [msg, setMsg] = useState('')


  const sendEmail = (e) => {
    e.preventDefault();

    const obj = { name, email, phone, company}
    const hasNoValueInObj = Object.values(obj).some(val => val === "")

    // const emptyFields =  Object.entries(obj).filter(([_, v]) => v == "").map(([k, _]) => k)

    // console.log(emptyFields[0])

    if (hasNoValueInObj) {
      alert(t("request_a_demo.messageSucess.validation_error_text"))
    } else {
      emailjs.sendForm('service_v5u2hy5', 'template_om3k4a1', form.current, 'PnhzkPM2oYpxJAveV')
        .then((result) => {
          alert(t("request_a_demo.messageSucess.sucess"));
        }, (error) => {
          console.log(error.message);
        });
    }

    setName('')
    setEmail('')
    setCompany('')
    setPhone('')
    setMsg('')

    e.target.reset();
  };

  return (
    <div className='container-form'>
      <div className='img-form'>
        <img src={ImgForm} alt="" />
      </div>
      <div className='form-signup'>
        <h1>{t("request_a_demo.title")}</h1>
        <form action="" ref={form} onSubmit={sendEmail}>
          <input
            name="name"
            type="text"
            id="name"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder={t("request_a_demo.placeholders.name_placeholder_text")}
            required
          />
          <input
            name="email"
            type="email"
            id="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder={t("request_a_demo.placeholders.email_placeholder_text")}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
            required
          />
          <input
            mask="(99)99999-9999"
            maskChar={null}
            name="phonenumber"
            id="phone"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            placeholder={t("request_a_demo.placeholders.phone_placeholder_text")}
            required
          />
          <input
            name="company"
            type="text"
            id="company"
            value={company}
            onChange={e => setCompany(e.target.value)}
            placeholder={t("request_a_demo.placeholders.company_placeholder_text")}
            required
          />
          <textarea
            name="msg"
            id="msg"
            value={msg}
            onChange={e => setMsg(e.target.value)}
            placeholder={t("request_a_demo.placeholders.comments_placeholder_text")}
          ></textarea>
        </form>
        <button id='btn-form' type="submit" onClick={sendEmail}>{t("buttons.send_button_text")}</button>
      </div>
    </div>
  )
}

export default Form